// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ContainerListView .container-list-toolbar .container-list-search-wrap {
	min-width: 140px;
}

.ContainerListView .container-list-toolbar .container-list-search-clear {
	width: 32px;
}

.ContainerListView .container-list-toolbar .container-list-search-clear i {
	pointer-events: none;
}

.ContainerListView .container-list-items {
	border: 1px solid var(--bs-border-color);
	border-radius: 0.375rem;
	background: #fff;
}

.ContainerListView .container-list-item {
	border-bottom: 1px solid var(--bs-border-color-translucent);
	cursor: pointer;
	gap: 0.1rem;
}

.ContainerListView .container-list-item:last-child {
	border-bottom: none;
}

.ContainerListView .container-list-item:hover {
	background: var(--bs-light-bg-subtle);
}

.ContainerListView .container-list-title {
	font-weight: 600;
}

.ContainerListView .container-list-actions .btn {
	width: 28px;
	height: 28px;
	padding: 0;
	display: inline-flex;
	align-items: center;
	justify-content: center;
}

.ContainerListView .container-list-actions .btn i {
	pointer-events: none;
}

.ContainerListView .container-list-actions [data-action="focus"] {
	color: #fff;
	border-color: #027bc4;
	background-color: #027bc4;
}

.ContainerListView .container-list-actions [data-action="focus"]:not(:disabled):hover,
.ContainerListView .container-list-actions [data-action="focus"]:not(:disabled):focus,
.ContainerListView .container-list-actions [data-action="focus"]:not(:disabled):active {
	color: #fff;
	border-color: #027bc4;
	background-color: #027bc4;
}

.ContainerListView .container-list-item-self {
	opacity: 0.8;
	cursor: default;
}

.container-list-focus-highlight {
	outline: 2px solid var(--bs-primary);
	outline-offset: 2px;
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
